export class ConfigurationsSideNavigationTree {
    static topItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'CONFIGURATION_COMMUNITY_ACCOUNTING',
            path: '/configurations/community-accounting-configurations',
            icon: '',
            text: 'Community Accounting',
            tooltip: 'Community Accounting Configurations',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'CONFIGURATION_COMMUNITY',
            path: '/configurations/community-configurations',
            icon: '',
            text: 'Community',
            tooltip: 'Community Configurations',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'CONFIGURATION_MODULES',
            path: '/configurations/modules-configurations',
            icon: '',
            text: 'Modules',
            tooltip: 'Modules Configurations',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'CONFIGURATION_SERVICES',
            path: '/configurations/services-configurations',
            icon: '',
            text: 'Services',
            tooltip: 'Services Configurations',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'CONFIGURATION_CLOSING_PORTAL',
            path: '/configurations/closing-portal-configurations',
            icon: '',
            text: 'Closing Portal',
            tooltip: 'Closing Portal Configurations',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'CONFIGURATION_BATCH_JOB_EMAIL',
            path: '/configurations/batch-job-emails-configurations',
            icon: '',
            text: 'Batch Job Emails',
            tooltip: 'Batch Job Emails Configurations',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'CONFIGURATION_PROCESS_TRACKER',
            path: '/configurations/process-tracker-configurations',
            icon: '',
            text: 'Process Tracker',
            tooltip: 'Process Tracker Configurations',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'CONFIGURATION_REPORT_TEMPLATE',
            path: '/configurations/report-templates-configurations',
            icon: '',
            text: 'Report Templates',
            tooltip: 'Report Templates Configurations',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'CONFIGURATION_RESPONSE_TEMPLATE',
            path: '/configurations/response-templates-configurations',
            icon: '',
            text: 'Response Templates',
            tooltip: 'Response Templates Configurations',
            items: []
        },
        {
            id: `${parentId}_10`,
            parentId,
            name: 'CONFIGURATION_ENFORCEMENT',
            path: '/configurations/enforcement-configurations',
            icon: '',
            text: 'Enforcement',
            tooltip: 'Enforcement Configurations',
            items: []
        }
    ];
}
